import { Maybe } from "@flockcover/flock-svc-core-types"
import { RebateCalculationPeriod } from "@shared/platform-api/generated"
import sortBy from "lodash.sortby"

export const makeInitialScoreData = (inputData: RebateCalculationPeriod[]): Maybe<number> => {
  const data = sortBy(inputData, `startTime`)
  const lastPeriod = data[data.length - 1]
  return lastPeriod?.insightsInitialSafetyScore ?? null
}
